import {CssDimensionRestDto, ImageContainerDimensionsRestDto} from "@/api/pharma-cms-content-block/models";
import {ObjectHorizontalPositionEnum} from "@/api/enums/object-horizontal-position-enum";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";

const DEFAULT_WIDTH_PERCENTAGE = 100 as number;

export class ImageContainerDimensionsRestDtoModel implements ImageContainerDimensionsRestDto {
    width_percentage?: number | null;
    alignment_code?: ObjectHorizontalPositionEnum | null;
    aspect_ratio_width?: number | null;
    aspect_ratio_height?: number | null;
    max_height?: CssDimensionRestDto | null;

    static createWithDefaults(): ImageContainerDimensionsRestDtoModel {
        const model: ImageContainerDimensionsRestDtoModel = new this();

        // A container that is switched on spans the full available width until narrowed.
        model.width_percentage = DEFAULT_WIDTH_PERCENTAGE;

        return model;
    }

    static cloneFrom(source: ImageContainerDimensionsRestDto): ImageContainerDimensionsRestDtoModel {
        const clone: ImageContainerDimensionsRestDtoModel = new this();

        clone.width_percentage = source.width_percentage;
        clone.alignment_code = source.alignment_code;
        clone.aspect_ratio_width = source.aspect_ratio_width;
        clone.aspect_ratio_height = source.aspect_ratio_height;

        if (source.max_height) {
            clone.max_height = CssDimensionRestDtoModel.cloneFrom(source.max_height);
        }

        return clone;
    }
}
